module.exports = __webpack_public_path__ + "img/ic_point_6.334de079.svg";